import React, { useState, useEffect } from "react";
// import { ThemeProvider } from "@mui/material/styles";
// import { Input } from "mdb-ui-kit"; // module
import "mdb-ui-kit/css/mdb.min.css";

import "./Styles/TransactionTypeForm.css";
import axios from "axios";
import ApiSettings from "../../../../../Settings/ApiSettings.json";

import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Cookies from "universal-cookie";
import { Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText, FormLabel,TextField,Typography } from "@mui/material";
import { useGlobalContext } from "../../../../../context";

const cookies = new Cookies();
// export interface State extends SnackbarOrigin {
//   open: boolean;
// }
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function AddStageTransactionTypeApproval(props) {
  const [object, setObject] = useState({
    name: props.object.name,
    id: props.object.id,
  });
  const [roleSelected, setRoleSelected] = useState([]);
  const [stages, setStages] = useState([]);
  const {roles,Approval, fetchData } = useGlobalContext();

  const [loading, setLoading] = useState(false);
  const [showBoxOfVarietiesList, setshowBoxOfVarietiesList] = useState(false);
  useEffect(() => {
    if (!cookies.get("role_id")) {
      window.location.href = "/";
    }
    fetchData("ROLES", "roles_list",{});
    fetchData("APPROVAL", "approval_statuses_list",{});

  }, []);

  const [dataOFVarieties, setdataOFVarieties] = useState([]);

  //   const [openSnackbar, setopenSnackbar] = useState(false);
  const [snackBar, setsnackBar] = useState({
    open: false,
    vertical: "bottom",
    horizontal: "center",
    message: "",
    severity: "",
  });
  const { vertical, horizontal, open } = snackBar;

  //get data of varieties Carrier ....
  const getDataOfApprovals = async (IpAddress) => {
    let data = null;
    try {
      data = await axios({
        method: "get",
        url: IpAddress + "/stage_transaction_type_approval/"+object.id,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-localization":'ar'
        },
      });

      if (data) {
        if (data.status == 200) {
          if(data.data.length>0){
            let arr=[]
             data.data.map((data)=>{
                arr.push({
                  sequence:data.approval_sequence,
                  is_mandatory:data.is_mandatory==1?true:false,
                  role_id:data.role_id,
                  check:true,
                 })
             })
             setRoleSelected(arr);
          }
          // setdataOFVarieties(data.data);
        }
      }
    } catch (err) {
      //   alert(err.message);
      setsnackBar({
        ...snackBar,
        message: err.message,
        severity: "warning",
        open: true,
      });
    }
  };



  useEffect(() => {
    setObject(props.object);
    getDataOfApprovals(ApiSettings.apiUrl);
  }, [props.object]);

  //here we will sent request with data to save it in our database.
  const sentFormData = async () => {
   
    setLoading(true);

    let data = null;
    try {
      data = await axios({
        method: "post",
        url: ApiSettings.apiUrl + "/stage_transaction_type_approval",
        data: {
          id: object.id,
          stage_transaction_type_approval: roleSelected
        },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-localization":'ar'
        },
      });

    //   console.log("update",data);
      if (data) {
        if (data.data.status == 200) {
          setLoading(false);
        //   setdataOFVarieties((item) => [...item, data.data.data]);
          setsnackBar({
            ...snackBar,
            message: data.data.message,
            severity: "success",
            open: true,
          });
          // props.setReloadData()
        } else if (data.data.status == 402) {
          //   alert(data.data.data.name);
          setsnackBar({
            ...snackBar,
            message: data.data.data.name,
            severity: "warning",
            open: true,
          });
        } else {
          //   alert(data.data.message);
          setsnackBar({
            ...snackBar,
            message: data.data.message,
            severity: "warning",
            open: true,
          });
        }
        setLoading(false);
      }
    } catch (err) {
      //   alert(err.message);
      setsnackBar({
        ...snackBar,
        message: err.message,
        severity: "error",
        open: true,
      });
      setLoading(false);
    }
  };

  //handle open snackbar ....
  const handleClick = () => {
    setsnackBar({ open: true, ...snackBar });
  };
  //handle clode snackbar
  const handleClose = () => {
    setsnackBar({ ...snackBar, open: false });
  };

  const handleInputChange = (event, role) => {
    const target = event.target;
    // console.log("ischecked",target.checked);
    if (target.checked) {
      setRoleSelected([...roleSelected, {
          sequence:null,
          is_mandatory:false,
          role_id:role.id,
          check:target.checked,
      }])
    }
    else {
      const roleSelectedlist = roleSelected.filter(function (item) {
        return item.role_id !== role.id
      })
      setRoleSelected(roleSelectedlist)
    }

  };

  const handleInputChangeSequence=(role,sequence)=>{
    // let getRole_check=false;
     let arr=[];
        roleSelected.map((data)=>{
            if(data.role_id==role.role_id){
              // getStages_check=true;
              arr.push({
                sequence:sequence,
                is_mandatory:role.is_mandatory,
                role_id:role.role_id,
                check:role.check,

              })
            }else{
              arr.push({
                sequence:data.sequence,
                is_mandatory:data.is_mandatory,
                role_id:data.role_id,
                check:data.check,

              })
            }
        })

      setRoleSelected(arr)
  
  }
  const handleInputChangeCheck=(role,check)=>{
    // let getRole_check=false;
     let arr=[];
        roleSelected.map((data)=>{
            if(data.role_id==role.role_id){
              // getStages_check=true;
              arr.push({
                sequence:data.sequence,
                is_mandatory:role.is_mandatory,
                role_id:role.role_id,
                check:check,
              })
            }else{
              arr.push({
                sequence:data.sequence,
                is_mandatory:data.is_mandatory,
                role_id:data.role_id,
                check:data.check,
              })
            }
        })

      setRoleSelected(arr)
  
  }
  const handleInputChangeIsmandatory=(role,isMandatory)=>{
    // let getRole_check=false;
     let arr=[];
        roleSelected.map((data)=>{
            if(data.role_id==role.role_id){
              // getStages_check=true;
              arr.push({
                sequence:role.sequence,
                is_mandatory:isMandatory?1:0,
                role_id:role.role_id,
                check:role.check,

              })
            }else{
              arr.push({
                sequence:data.sequence,
                is_mandatory:data.is_mandatory,
                role_id:data.role_id,
                check:data.check,
              })
            }
        })

      setRoleSelected(arr)
  
  }
  const getExistsRoleSelected=(role)=>{
    let check_role=false;
    roleSelected.map((data)=>{
        if(data.role_id==role.id){
          check_role=true;
        }
    })
    return check_role;
  }

  const getDataOfCheckStatus=(role)=>{
    if(roleSelected.length>0){
       let chck=0;
        roleSelected.map((data)=>{  
          if(data.role_id===role.id){
            chck=1;
          }
        })
        if(chck==1){
          return true;
        }
        // return false;
    }
    return false
  }

  // Normalize roles to an array whether it's already an array or a paginated object
  const rolesList = Array.isArray(roles) ? roles : (roles && Array.isArray(roles.data) ? roles.data : []);
  
  return (
    <div
    className={`ModalFormContainer rounded-3 px-2 ${props.inactive === false ? "activeSideMenu" : ""}
      }`}
      style={{height:'80%'}}
  >
    {/* header of form section  */}
    <div className="container-lg py-4 px-2 ">
      <div className="row">
        <div className="col-md-12 ">
          <div className="toSection d-flex justify-content-center align-items-center">
            <span className="FormName">مراحل الموافقة لمرحلة  {object?.stage?.name}</span>
          </div>
        </div>
      </div>
    </div>

    {/* section1 here...  */}
    <div className="section1 container-lg py-4 px-2 pe-4">
      <div className="row">
        <div className="col-md-12 align-items-center  d-flex " style={{
          flexDirection: 'column',
          borderStyle: 'solid',
          borderColor: 'rgb(95, 123, 138)',
          borderWidth: '2px',
          borderRadius: '10px',
          paddingTop: '10px',
          paddingBottom: '10px'
        }}>
          
          <FormControl sx={{ m: 3 }} component="fieldset" variant="standard">
            <FormLabel component="legend">اختر من مراحل الموافقة الاتية</FormLabel>
            <FormGroup>
            {rolesList.map((role) => {
             
              return(
              <div style={{
                    display: "flex",
                    flexDirection: "row",
                    // flexFlow: "row wrap",
                     
                    // border: "1px solid",
                    borderColor: "#5f7b8a",
                    borderRadius: 10,
                    margin: "0 10px",
                    padding:"0 10px", 
                    paddingBottom: 10,
                }}>
                   <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "33%",
                        // flex:1,
                        minWidth: 200,
                        marginTop: 10,
                        paddingTop: 10,
                        paddingLeft: 10,
                        // paddingRight: 10,
                        justifyContent: "start",
                        alignItems: "center",
                      }}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox checked={getDataOfCheckStatus(role)} onChange={(e) => handleInputChange(e, role)} name="gilad" />
                        }
                        label={role.name}
                      />
                   </div>

                    {
                      roleSelected.map((data)=>(
                          data.role_id==role.id ?
                          <div
                          style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "33%",
                              // flex: 1,

                              minWidth: 200,
                              marginTop: 10,
                              paddingTop: 10,
                              paddingLeft: 10,
                              paddingRight: 10,
                              justifyContent: "center",
                              alignItems: "center",
                          }}
                          >
                          <FormControl fullWidth>
                              <TextField
                              label="رقم التسلسل"
                              variant="outlined"
                              // disabled={!data.check}
                              value={parseInt(data.sequence)}
                              type="number"
                              onChange={(e)=>{
                                  handleInputChangeSequence(data,parseInt(e.target.value));
                              }}
                      
                              />
                          </FormControl>
                          <Typography className="fontForError">
                          
                          </Typography>
                          </div>:null
                      ))
                    }

                    {
                      !getExistsRoleSelected(role) ?
                        <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "33%",
                            // flex: 1,

                            minWidth: 200,
                            marginTop: 10,
                            paddingTop: 10,
                            paddingLeft: 10,
                            paddingRight: 10,
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                        >
                        <FormControl fullWidth>
                            <TextField
                            label="رقم التسلسل"
                            variant="outlined"
                            disabled={true}
                            // value={data.squence}
                            type="number"
                            onChange={(e)=>{
                                // handleInputChangeSequence(data,parseInt(e.target.value));
                            }}
                    
                            />
                        </FormControl>
                        <Typography className="fontForError">
                        
                        </Typography>
                        </div>:null 
                    }

                    {
                      roleSelected.map((data)=>(
                          data.role_id==role.id ?
                          <div
                          style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "33%",
                              // flex: 1,

                              minWidth: 200,
                              marginTop: 10,
                              paddingTop: 10,
                              paddingLeft: 10,
                              paddingRight: 10,
                              justifyContent: "center",
                              alignItems: "center",
                          }}
                          >
                          <FormControl fullWidth>
                          <FormControlLabel
                              control={
                              <Checkbox checked={data.is_mandatory}  onChange={(e) => handleInputChangeIsmandatory(data,e.target.checked)} name="gilad" />
                              }
                              label={"يجب الموافقة"}
                          />
                          </FormControl>
                          <Typography className="fontForError">
                          
                          </Typography>
                          </div>:null
                      ))
                    }

                    {
                      !getExistsRoleSelected(role) ?
                        <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "33%",
                            // flex: 1,

                            minWidth: 200,
                            marginTop: 10,
                            paddingTop: 10,
                            paddingLeft: 10,
                            paddingRight: 10,
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                        >
                        <FormControl fullWidth>
                        <FormControlLabel
                            control={
                            <Checkbox  disabled={true}  name="gilad" />
                            }
                            label={"يجب الموافقة"}
                        />
                        </FormControl>
                        <Typography className="fontForError">
                        
                        </Typography>
                        </div>:null
                    }

                 
               
              </div>)
            })}
              
            </FormGroup>
            <FormHelperText>تستطيع اختيار اكثر من واحدة</FormHelperText>
          </FormControl>




          <Button
            variant="contained"
            className="mx-3 section1CarrerName section1Button mt-4 pt-1"
            onClick={() => {
              sentFormData();
            }}
          >
            {!loading ? (
              "تحديث"
            ) : (
              <div className="spinner-border " role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            )}
          </Button>

        </div>
      </div>
    </div>
    {/* snack alert box here ... */}
    <Snackbar
      open={snackBar.open}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ vertical, horizontal }}
    >
      <Alert
        onClose={handleClose}
        severity={snackBar.severity}
        sx={{ width: "100%" }}
      >
        {snackBar.message}
      </Alert>
    </Snackbar>
  </div>
  );
}
